(() => {
  'use strict';

  const LOADER_VERSION = 1;

  if (window.WUBNewsletterPopupLoader?.version === LOADER_VERSION) {
    window.WUBNewsletterPopupLoader.init?.(document);
    return;
  }

  const script = document.currentScript;
  if (!script?.src) return;

  function sibling(filename) {
    const url = new URL(script.src, window.location.href);
    url.pathname = url.pathname.replace(/[^/]+$/, filename);
    url.search = '';
    url.hash = '';
    return url.href;
  }

  const loaderSrc = sibling('wub-newsletter-popup-loader.js');
  const styleSrc = sibling('wub-newsletter-popup-runtime.css');
  const runtimeSrc = sibling('wub-newsletter-popup-runtime.js');

  function initLoader() {
    window.WUBNewsletterPopupLoader?.init?.(document);
  }

  const existing = document.querySelector('script[data-wub-popup-loader]');
  if (existing) {
    if (window.WUBNewsletterPopupLoader?.version === LOADER_VERSION) initLoader();
    else existing.addEventListener('load', initLoader, { once: true });
    return;
  }

  const node = document.createElement('script');
  node.src = loaderSrc;
  node.defer = true;
  node.dataset.wubPopupLoader = 'true';
  node.dataset.wubPopupStyleSrc = styleSrc;
  node.dataset.wubPopupRuntimeSrc = runtimeSrc;
  node.addEventListener('load', initLoader, { once: true });
  node.addEventListener('error', () => {
    console.error('WUB newsletter popup loader failed to load.');
  }, { once: true });
  document.head.appendChild(node);
})();
